import { callApi } from "@src/api/callApi"
import { THEFT } from "@src/api/types"

export type PATCH_THEFTS_BODY = {
  police_case_number?: string | null
}

export const patchTheftsId = (id: number, body: PATCH_THEFTS_BODY) =>
  callApi<PATCH_THEFTS_BODY, THEFT>({
    method: "PATCH",
    path: `/thefts/${id}`,
    body,
  })
